import React from 'react';
import Footer from '../components/Footer';


function Contact() {
    return (
        <div>
            <h2>Contact Page</h2>
            <Footer />
        </div>
    );
}

export default Contact;